import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {smoothScrollToTop} from "./utils";

const usePathNameChangeScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		smoothScrollToTop();
	}, [pathname]);
};

export default usePathNameChangeScrollToTop;